<template>
  <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
    <v-card>
      <div class="d-flex align-end mb-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">任务信息</span>
      </div>

      <v-form v-model="valid" ref="form" class="px-6 py-3">
        <v-text-field
          v-model="form.sortNum"
          label="任务编号"
          :rules="rules.sortNum"
          hint="请输入任务编号"
        ></v-text-field>

        <v-text-field v-model="form.name" label="任务名称" required :rules="rules['taskName']">
        </v-text-field>
        <v-select
          v-model="form.project"
          :items="projectList"
          :label="projectTypeLabel"
          no-data-text="暂未创建章节"
          required
          :rules="rules['taskEditor']"
          item-text="name"
          item-value="_id"
        ></v-select>
        <v-select
          v-model="form.taskEditor"
          :items="taskSceneList"
          label="任务场景"
          no-data-text="暂未创建任务场景"
          required
          :rules="rules['taskEditor']"
          item-text="name"
          item-value="_id"
        ></v-select>
        <v-select
          v-model="form.taskEditorRuleId"
          :items="configList"
          label="逻辑规则"
          item-text="ruleName"
          item-value="id"
          no-data-text="未配置逻辑规则"
        ></v-select>
        <v-select
          v-model="form.taskGraphVersion"
          :items="[
            { label: '详细设计', value: 'detail' }
            , { label: '模板设计', value: 'template' }
          ]"
          label="任务模式"
          no-data-text="暂未创建任务场景"
          required
          :rules="rules['taskGraphVersion']"
          item-text="label"
          item-value="value"
        ></v-select>
        <!-- <v-select
          v-model="form.cognitionType"
          :items="taskCognitionList"
          label="认知"
          required
          :rules="rules['cognitionType']"
          item-text="name"
          item-value="value"
        ></v-select> -->
        <!-- <v-select v-model="form.knowlegeType" :items="taskKnowlegeList" label="性质" required
          :rules="rules['knowlegeType']" item-text="name" item-value="value"></v-select> -->
        <!-- <v-select v-model="form.taskMode" :items="taskModeList" label="任务模式" required :rules="rules['taskMode']"
          item-text="name" item-value="value"></v-select> -->

        <v-textarea
          class="mt-2"
          v-model="form.description"
          label="任务描述"
          auto-grow
          clearable
        ></v-textarea>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="confirm">提交</v-btn>
        <v-btn color="gray" @click.stop="cancel">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { setConfigDatas } from '@/api/task/task';
import { mapGetters } from 'vuex';
let regs = /^[0-9]*$/;
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['project', 'sceneList', 'taskInfo', 'course', 'projectType']),
    dialogStatus: {
      get() {
        this.form = Object.assign({}, this.$store.state.task.checkTaskInfo);
        const status = this.$store.state.task.showTaskEdit;
        return status;
      },
      set(val) {
        this.$store.dispatch('task/reverseShowTaskEdit', val);
      },
    },
    taskSceneList() {
      this.form = Object.assign({}, this.$store.state.task.checkTaskInfo);
      return this.$store.state.editor.sceneList;
    },
    projectList() {
      return this.course !== undefined && Array.isArray(this.course.children) ? this.course.children : []
    },
    projectTypeLabel() {
      let dict = {};
      dict['xm'] = '项目';
      dict['zj'] = '章节';
      dict['qj'] = '情境';
      return this.projectType && dict[this.projectType] ? dict[this.projectType] : '章节'
    }
  },
  data: () => ({
    configId: '',
    configList: [],
    valid: false,
    treeData: {},
    form: {
      name: '',
      taskMode: '',
      taskEditor: '',
      description: '',
      configId: '',
      isPublic: false,
      sortNum: 0,
    },
    rules: {
      name: [v => !!v || '请填写任务名称'],
      taskEditor: [v => !!v || '请选择任务场景'],
      cognitionType: [v => !!v || '请选择认知类型'],
      sortNum: [
        v => {
          if (!regs.test(v)) {
            return '请输入正确的任务编号';
          }
          return true;
        },
      ],
    },
    nodeText: '',
    taskNodeList: [],
    taskModeList: [
      { value: 'study', name: '学习' },
      { value: 'train', name: '练习' },
      { value: 'exam', name: '考核' },
    ],
    taskCognitionList: [
      { value: 'memory', name: '记忆' },
      { value: 'understand', name: '理解' },
      { value: 'apply', name: '应用' },
      { value: 'analyze', name: '分析' },
      { value: 'appraise', name: '评价' },
      { value: 'create', name: '创造' },
    ],
    taskKnowlegeList: [
      { value: 'fact', name: '事实性知识' },
      { value: 'concept', name: '概念性知识' },
      { value: 'program', name: '程序性知识' },
    ],
  }),
  methods: {
    confirm() {
      if (!this.form.taskEditor) {
        this.$store.dispatch('global/showWarningMsg', '请选择任务场景');
        return;
      }
      if (!this.form.sortNum) {
        this.$store.dispatch('global/showWarningMsg', '请选择任务编号');
        return;
      }
      this.$refs.form.validate();
      if (this.valid) {
        this.form.cognitionType = 'memory'
        this.form.taskMode = 'study'
        this.$store.dispatch('task/saveTask', this.form);
      }
    },
    cancel() {
      this.$store.dispatch('task/reverseShowTaskEdit', false);
    },
    getConfig() {
      this.configList = [];
      setConfigDatas({
        taskEditor: this.form.taskEditor,
      }).then(res => {
        if (res.code == '200' && res.data) {
          this.configList = [];

          this.configList =
            typeof res.data.ruleDefinitionList === 'object'
              ? res.data.ruleDefinitionList
              : JSON.parse(res.data.ruleDefinitionList);
        }
      });
    },
  },
  watch: {
    'form.taskEditor'(val) {
      this.getConfig();
    },
  },
  mounted() {
    this.getConfig();
  },
};
</script>
